<template>
  <div>

    <memlist-modal size="xl" ref="files-history">
      <ImportFilesRowDetails
        v-if="selected_item"
        v-bind:value="selected_item"
      />
    </memlist-modal>

<!-- table-head-custom table-vertical-center table-head-bg table-borderless -->
    <memlist-static-table
      id="import-files-table"
      :fields="headers"
      :items="files"
      :per_page="per_page"
      :current_page="current_page"
      @row-clicked="handle_row_clicked"
    >
      <!-- this is a built in exand slot which will insert a new row inside the table when clicking on a row -->
      
      <template #cell(history)="row">

        <div v-if="row.item.history.length > 0">
          <memlist-table-button class="mr-2" @click="show_history_clicked(row.item)" svg="/assets/svg/rewind-clock.svg" :tooltip="$t('COMMON.SHOW_HISTORY')"/>
        </div>
        <div v-else>
          <p>-</p>
        </div>

      </template>

      <template #cell(upload_file)="row">
        <memlist-button @click.prevent="upload_file_clicked(row.item.type)" variant="primary">{{$t('PAGES.FAITH.UPLOAD_FILE')}}</memlist-button>
      </template>


    </memlist-static-table>

  </div>

</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import ImportFilesRowDetails from '@/view/pages/ml/faith/import/ImportFilesRowDetails.vue';


export default {
  name: 'ImportFilesTable',
  mixins: [ toasts ],
  props: ['files','show_create'],
  emits: ['create_company_period', 'select_company', 'select_company_period', 'delete_company_period', 'on_upload_file_clicked'],
  components: {
    ImportFilesRowDetails
  },
  watch: {

  },
  computed:{
    ...mapGetters(['isTHS','currentCompanyId','currentPeriodId']),
  },
  mounted() {
    if (this.isTHS) {
      // do something as THS admin?
    }
  },
  methods: {

    is_empty(name) {
      if (!name || name.length === 0 || name === ' ') {
        return true;
      }
      return false;
    },

    show_history_clicked(item) {
      this.selected_item = item;

      this.$refs['files-history'].show();
    },

    upload_file_clicked(type) {
      this.$emit('on_upload_file_clicked', type);
    },

    handle_row_clicked(row, index, e) {
      if (row._showDetails) {
        row._showDetails = false;
      }
      else {
        row._showDetails = true;
      }
      // Vue3 compatability for Vue.set
      row = { ...row };
    },

    add_new_row(item) {
      item.newRow = this.newRowValue;
      // Vue3 compatability for Vue.set
      item = { ...item };

      this.newRowValue = "";
    },

    download_company_period_report_clicked(id) {
      this.toastr('danger', this.$t('COMMON.ERROR'), 'Ej implementerat');
    },

    replace_null_empty(value) {
      if (value === null || value === undefined) {
        return '';
      }

      return value;
    },

    create_company_period_clicked() {
      this.$emit('create_company_period', company_period_id);
    },

    select_company_clicked(company_id) {
      this.$emit('select_company', company_id);
    },

    select_company_period_clicked(company_period_id) {
      this.$emit('select_company_period', company_period_id);
    },

    delete_company_period_clicked(company_period_id) {
      this.$emit('delete_company_period', company_period_id);
    }

  },
  data() {
    return {
      selected_item: null,
      newRowValue: "",
      filters: {
        text: ''
      },
      total_rows: 0,
      per_page: 100,
      current_page: 1,
      per_page_options: [
        100, 250, 500
      ],
      headers: [
        {
          formatter: (_, __, item) => {
            return this.$t('PAGES.FAITH.' + item.type);
          },
          key: 'type',
          label: this.$t('PAGES.FAITH.FILE_TYPE'),
          sortable: false,
          thClass: 'td-short5',
          tdClass: 'td-short5'
        },
        {
          key: 'period_id',
          label: this.$t('PAGES.FAITH.FOR_PERIOD'),
          sortable: false,
          thClass: 'td-short4',
          tdClass: 'td-short4',
          formatter: (_, __, item) => {
            return item.period ? item.period.year : '-';
          },
        },

        {
          key: 'created_at',
          label: this.$t('PAGES.FAITH.GENERATED_AT'),
          sortable: false,
          thClass: 'td-short4',
          tdClass: 'td-short4',
          formatter: (_, __, item) => {
            return '';
          },
        },
        {
          key: 'user',
          label: this.$t('PAGES.FAITH.USER_NAME'),
          sortable: false,
          thClass: 'td-short4',
          tdClass: 'td-short4',
          formatter: (_, __, item) => {
            return '';
          },
        },

        {
          key: 'history',
          label: this.$t('PAGES.FAITH.HISTORY'),
          sortable: false,
          thClass: 'td-short4',
          tdClass: 'td-short4',
        },

        {
          key: 'upload_file',
          label: this.$t('PAGES.FAITH.UPLOAD_FILE'),
          sortable: false,
          thClass: 'td-overflow',
          tdClass: 'td-overflow'
        },
        {
          key: 'expand',
          label: "",
          sortable: false
        },
      ],

    };
  }
};
</script>
